"use strict";

var AssetData = require("./assetData.js");

var ContentServerHandler = require("./contentServerHandler.js");

var NonShareableDataRoot = require("./src/datamodel/nonShareableDataRoot.js");

var logError = require("./error.js");


//TODO: move this
String.prototype.endsWith = function(suffix) {
    return this.indexOf(suffix, this.length - suffix.length) !== -1;
};

var ContentServerClient = function(config, userController) {
    console.log("Creating ContentServerClient as Data Manager");
    if (!config.serverurl.endsWith('/')) config.serverurl += '/';
    this.contentServerURL = config.serverurl + config.tenant;
    console.assert(this.contentServerURL);
    this.session = config.session; //optional
    this.assetTypeRouter = config.assetTypeRouter;
    // this.datamodel = config.datamodel;
    // console.assert(this.datamodel, 'datamodel undefined');
    // this.datamodel_dependencies = config.datamodel_dependencies;
    // console.assert(this.datamodel_dependencies, 'datamodel_dependencies undefined');
    this.userController = userController;
    // optional usercontroller to logout in case 401 UNAUTHORIZED occures
    if(!this.userController) {
        console.log("No user controller detected, using noop");
        this._initUserControllerNoop();
    }
    if(this.session) {
        ContentServerHandler.init(this.session);
    }
};
module.exports = ContentServerClient;

ContentServerClient.prototype._initUserControllerNoop = function() {
    this.userController = {
        getModel: function() {
            return {
                name: function () {
                    return false;
                },
                id: function () {
                    return false;
                }
            }
        }
    }
}

ContentServerClient.prototype.getAssetPath = function(type, id){
    var path = this.contentServerURL;
    console.assert(this.assetTypeRouter[type], "Content Server: Unknown asset type: " + type);
    path += this.assetTypeRouter[type];
    if (id) path += "/" + id ;

    return path;
};

ContentServerClient.prototype.getUserInfo = function() {
    if(this.user_info == undefined) {
        var response_json = ContentServerHandler.csRequest('GET', this.contentServerURL + '/actions/userIdFromSession', {
            'Content-Type': 'application/json'
        }, null, true, true, false, "attempting to retrieve user's session ID.",  logError.criticality.CRITICAL);

        this.user_info = {
            user_id:response_json.id,
            user_name:response_json.name,
            email:response_json.email
        };
    }
    return this.user_info;
};

ContentServerClient.prototype.getUserId = function() {
    return this.getUserInfo().user_id;
};

ContentServerClient.prototype.createResource = function(resource, type, sync){
    var path = this.getAssetPath(type);
    return ContentServerHandler.csRequest('POST', path, {
            'Content-Type': 'application/json'
        }, resource, sync, true, false, "attempting to create a new Resource.", logError.criticality.MAJOR, {
            "Username": this.userController.getModel().name(),
            "UserID": this.userController.getModel().id()
        });
};

ContentServerClient.prototype.createVersionedResource = function(resource, assetType, datamodel_version, versionName, versionDescription, assetData) {
    var self = this;
    var assetId = null;

    return this.createResource(resource, assetType, false)
    .then(function(asset){
        assetId = asset["id"];
        return self.getEmptyColabDoc(assetType, assetId, datamodel_version, false);
    })
    .then(function(res) {
        var nonShareableDataRoot = new NonShareableDataRoot();
        nonShareableDataRoot.attachData(assetData);
        var colabDoc = {};
        colabDoc['header'] = {
            "assetId": res["header"]["assetId"],
            "assetType": res["header"]["assetType"],
            "datamodel_version": res["header"]["datamodel_version"],
        }
        colabDoc['body'] = nonShareableDataRoot.jsonify(assetData);
        colabDoc['undo'] = [];
        colabDoc['redo'] = [];
        return self.createResourceVersion(assetType, assetId, versionName, versionDescription, colabDoc);
    })
    .then(function(versionInfo) {
        return {
            id: assetId,
            version: versionInfo.version
        }
    });
};

ContentServerClient.prototype.cloneResource = function(type, id, sync){
    var path = this.getAssetPath(type, id) + '/clone';
    return ContentServerHandler.csRequest('POST', path, {
            'Content-Type': 'application/json'
        }, {}, sync, true, false, "attempting to clone a new Resource.", logError.criticality.MAJOR, {
            "Username": this.userController.getModel().name(),
            "UserID": this.userController.getModel().id(),
            "AssetID": id
        });
};


ContentServerClient.prototype.createHub = function(hubName, sync) {
    var body = {"name": hubName};
    var path = this.contentServerURL + "/hubs";
    return ContentServerHandler.csRequest('POST', path, {
            'Content-Type': 'application/json'
        }, body, sync, true, false, "attempting to create a new HUB.", logError.criticality.MAJOR, {
            "Username": this.userController.getModel().name(),
            "UserID": this.userController.getModel().id(),
            "FolderName": hubName
        });
};

/*
    Retrieves all hubs user is owner of.
    If includeMemberOf is true it retrieves all hubs user is both owner of and member of.
 */
ContentServerClient.prototype.getHubs = function(includeMemberOf, sync) {
    var path = this.contentServerURL + "/hubs";

    if(includeMemberOf) {
        path = this.contentServerURL + "/hubs/memberownerof";
    }

    return ContentServerHandler.csRequest('GET', path, {
            'Content-Type': 'application/json'
        }, null, sync, true, false, "attempting to get the list of HUBS.", logError.criticality.MAJOR, {
            "Username": this.userController.getModel().name(),
            "UserID": this.userController.getModel().id()
        });
};

ContentServerClient.prototype.getAnyHubForTestPurposes = function() {
    return this.getHubs()
    .then( hubs => {
        if(hubs.hubs.length < 1) {
            return this.createHub("AHubCreatedForTestPurposes")
        } else {
            return hubs.hubs[0];
        }
    })
}

ContentServerClient.prototype.updateResource = function(type, id, resource, sync){
    var path = this.getAssetPath(type, id);
    return ContentServerHandler.csRequest('PUT', path, {
            'Content-Type': 'application/json'
        }, resource, sync, true, false, "attempting to directly update a Resource.", logError.criticality.MAJOR, {
            "Username": this.userController.getModel().name(),
            "UserID": this.userController.getModel().id(),
            "AssetID": id
        });
};

ContentServerClient.prototype.patchResource = function(type, id, resource, sync){
    var path = this.getAssetPath(type, id);
    return ContentServerHandler.csRequest('PATCH', path, {
            'Content-Type': 'application/json'
        }, resource, sync, true, false, "attempting to directly patch a Resource.", logError.criticality.MAJOR, {
            "Username": this.userController.getModel().name(),
            "UserID": this.userController.getModel().id(),
            "AssetID": id
        });
};

ContentServerClient.prototype.getResource = function(type, id, sync){
    var self = this;
    var path = this.getAssetPath(type, id);
    function f() {
        return ContentServerHandler.csRequest('GET', path, {
                'Content-Type': 'application/json'
            }, null, sync, true, false, "attempting to retrieve a "+type+" resource.", logError.criticality.MAJOR, {
                "Username": self.userController.getModel().name(),
                "UserID": self.userController.getModel().id(),
                "AssetID": id
            });
    }
    if(sync)
        return new AssetData(f());
    else
        return f().then(function(asset) { return new AssetData(asset); });
};

ContentServerClient.prototype.deleteResource = function(type, id, sync){
    var path = this.getAssetPath(type, id);
    return ContentServerHandler.csRequest('DELETE', path, {
            'Content-Type': 'application/json'
        }, null, sync, true, false, "attempting to delete a "+type+".", logError.criticality.MAJOR, {
            "Username": this.userController.getModel().name(),
            "UserID": this.userController.getModel().id(),
            "AssetID": id
        });
};

ContentServerClient.prototype.publishResource = function(type, id, action, recursive, sync){
    var path = this.getAssetPath(type, id);
    return ContentServerHandler.csRequest('PUT', path + '/publish', {
            'Content-Type': 'application/json'
        }, {'action': action, 'recursive': recursive}, sync, true, false, "attempting to publish a "+type+".", logError.criticality.MAJOR, {
            "Username": this.userController.getModel().name(),
            "UserID": this.userController.getModel().id(),
            "AssetID": id
        });
};

ContentServerClient.prototype.escapeSpecialCharacters = function(query) {
    return encodeURIComponent(query);
};

ContentServerClient.prototype.searchResources = function(type, library, queryFields, searchFilters, pathSuffix, sync){
    var self = this;

    if(!pathSuffix) pathSuffix = '';

    var query = "?";

    queryFields.q = this.escapeSpecialCharacters(queryFields.q);

    for (var key in queryFields) {
        if (queryFields.hasOwnProperty(key)) {
            query += "&"+key+"="+queryFields[key];
        }
    }
    if(searchFilters && searchFilters.length && searchFilters.length > 0){
        query += "&qf=name";
        for (var i = 0; i < searchFilters.length; i++) {
            if(searchFilters[i].val){
                var val = searchFilters[i].val;
                query += "&properties."+searchFilters[i].key+"="+val;
            }
            else if(searchFilters[i].min && searchFilters[i].max) {
                query += "&properties."+searchFilters[i].key+"=["+searchFilters[i].min+','+searchFilters[i].max+']';
            }
        }
    }

    var path = this.getAssetPath(type);
    if (library) path = this.contentServerURL + "/libraries/" + library + "/search";

    function f() {
        return ContentServerHandler.csRequest('GET', path + pathSuffix + query, {
            'Content-Type': 'application/json'
        }, null, sync, true, false, "attempting to preform a search query.", logError.criticality.MAJOR, {
            "Username": self.userController.getModel().name(),
            "UserID": self.userController.getModel().id(),
            "Query": query
        });
    }
    if(sync)
        return f().map(a => new AssetData(a));
    else
        return f().then(res => {
            res.results = res.results.map(a => new AssetData(a));
            return res;
        });
};

// DONT USE THIS!  only to be used for old migration code...
// new assets will no longer have a collab doc.  use createResourceVersion instead.
// ContentServerClient.prototype.updateResourceColabDoc = function(type, id, colabDoc, sync){
//     var path = this.getAssetPath(type, id) + '/colabDoc';
//     // construct a correct new collabdoc Json before pushing it (this means with correct header (no injected fields from CS) + undo and redo stacks available) TODO: not the best / most robust solution: find a better one
//     var json = {
//         "header": {
//             "assetId": id,
//             "assetType": type,
//             "datamodel_version": colabDoc["header"]["datamodel_version"],
//             "colabDocId": colabDoc["header"]["colabDocId"],
//         },
//         "body": colabDoc["body"],
//         "undo": [],
//         "redo": []
//     };
//     return ContentServerHandler.csRequest('POST', path, {
//         'Content-Type': 'application/json'
//     }, json, sync, false, false, "attempting to update collab doc.", logError.criticality.MAJOR, {
//         "Username": this.userController.getModel().name(),
//         "UserID": this.userController.getModel().id(),
//         "AssetID": id
//     });
// };

ContentServerClient.prototype.updateResourceModel = function(type, id, modelFile, sync, isFormData){
    var path = this.getAssetPath(type, id) + '/model';

    return ContentServerHandler.csRequest('POST', path, {}, modelFile, sync, false, isFormData, "attempting to update 3d model.", logError.criticality.MAJOR, {
        "Username": this.userController.getModel().name(),
        "UserID": this.userController.getModel().id(),
        "AssetID": id
    });

};

ContentServerClient.prototype.getResourceColabDoc = function(type, id, datamodel_version, sync){
    console.assert(!this.datamodel_version, 'datamodel_version undefined');
    var path = this.getAssetPath(type, id) + '/colabDoc?datamodel_version=' + datamodel_version;
    return ContentServerHandler.csRequest('GET', path, {
        'Content-Type': 'application/json'
    }, null, sync, false, false, "attempting to retrieve collab doc.", logError.criticality.MAJOR, {
        "Username": this.userController.getModel().name(),
        "UserID": this.userController.getModel().id(),
        "AssetID": id
    });
};

// to be used only to migrate a collab doc from the collab service to a draft.
ContentServerClient.prototype.migrateCollabDocToDraft = function(type, id, datamodel_version, sync){
    console.assert(!this.datamodel_version, 'datamodel_version undefined');
    var path = this.getAssetPath(type, id) + '/colabDoc/migrateToDraft?datamodel_version=' + datamodel_version;
    return ContentServerHandler.csRequest('GET', path, {
        'Content-Type': 'application/json'
    }, null, sync, false, false, "attempting to migrate a collab doc to a draft savepoint.", logError.criticality.MAJOR, {
        "Username": this.userController.getModel().name(),
        "UserID": this.userController.getModel().id(),
        "AssetID": id
    });
};

ContentServerClient.prototype.createResourceVersion = function(type, id, name, description, colabDoc, sync){
    console.assert(name !== undefined, "No name in call to createResourceVersion");
    console.assert(description !== undefined, "No description in call to createResourceVersion");
    console.assert(colabDoc !== undefined, "No dolabDoc in call to createResourceVersion");
    var path = this.getAssetPath(type, id) + '/versions';
    return ContentServerHandler.csRequest('POST', path, {
        'Content-Type': 'application/json'
    }, {"name": name, "description": description, "colabDoc": colabDoc}, sync, true, false, "attempting to create a new version.", logError.criticality.MAJOR, {
        "Username": this.userController.getModel().name(),
        "UserID": this.userController.getModel().id(),
        "AssetID": id
    });
};

ContentServerClient.prototype.createResourceDraft = function(type, id, colabDoc, sync){
    var path = this.getAssetPath(type, id) + '/drafts';
    return ContentServerHandler.csRequest('POST', path, {
        'Content-Type': 'application/json'
    }, {"colabDoc": colabDoc}, sync, true, false, "attempting to create a resource draft.", logError.criticality.MAJOR, {
        "Username": this.userController.getModel().name(),
        "UserID": this.userController.getModel().id(),
        "AssetID": id
    });
};

ContentServerClient.prototype.getResourceSnapshot = function(type, id, version, datamodel_version, sync){
    console.assert(version !== undefined, "No version in call to getResourceSnapshot");
    var path = this.getAssetPath(type, id) + '/versions/' + version + '/colabDoc?';
    if(datamodel_version != null) path += 'datamodel_version=' + datamodel_version;
    return ContentServerHandler.csRequest('GET', path, {
            'Content-Type': 'application/json'
    }, null, sync, true, false, "attempting to retrieve a snapshot.", logError.criticality.MAJOR, {
        "Username": this.userController.getModel().name(),
        "UserID": this.userController.getModel().id(),
        "AssetID": id
    });
};

ContentServerClient.prototype.getMultipleResource = function(references, sync){
    var self = this;
    var path = this.contentServerURL + '/actions/multiResource?';
    references.forEach(function(ref) {
        path += '&' + ref.type.toLowerCase() + ":" + ref.id;
    });

    function f() {
        //response is an object which contains resource objects
        return ContentServerHandler.csRequest('GET', path, {
            'Content-Type': 'application/json'
        }, null, sync, true, false, "attempting to get multiple resources.", logError.criticality.MAJOR, {
            "Username": self.userController.getModel().name(),
            "UserID": self.userController.getModel().id()
        });
    }

    //modify response so that asset info in response is replaced with assetData in case of no error
    function updateResponseWithAssetData(response) {
        for(var longId in response) {
            //replace resource info with asset data in case of no error
            if(!response[longId].error) {
                response[longId] = new AssetData(response[longId]);
            }
        }

        return response;
    }

    if(sync) {
        return updateResponseWithAssetData(f());
    } else {
        return f().then(updateResponseWithAssetData);
    }
};

ContentServerClient.prototype.getMultipleResourceSnapshots = function(references, datamodel_version, sync){
    var path = this.contentServerURL + '/actions/multiSavedSnapshot?';
    path += '&datamodel_version=' + datamodel_version;
    references.forEach(function(ref) {
        path += '&' + ref.type + ":" + ref.id + ":" + ref.version;
    });
    return ContentServerHandler.csRequest('GET', path, {
            'Content-Type': 'application/json'
        }, null, sync, true, "attempting to get multiple resource snapshots.", logError.criticality.MAJOR, {
            "Username": this.userController.getModel().name(),
            "UserID": this.userController.getModel().id()
        });
};

// TODO this function
ContentServerClient.prototype.checkModelExists = function(fileData){
    // TODO check to see if this data exists.

    // if does not exist,
        return new Promise(function(resolve, reject){
            resolve({
                exists: false
            });
        })

    //  else if resource does exist
        // return {
            // exists: true,
            // assetId: info.id,
            // assetType: info.type
        //}
}

ContentServerClient.prototype.getResourceModel = function(type, id, ignoreErrors, sync){

    var criticality = (ignoreErrors)? logError.criticality.MINOR :logError.criticality.MAJOR;
    var path = this.getAssetPath('3dmodel', id) + '/' + type;
    return ContentServerHandler.csRequest('GET', path, {
        'Content-Type': 'multipart/form-data'
    }, null, sync, false, false, "attempting to get a 3D model file.", criticality, {
        "Username": this.userController.getModel().name(),
        "UserID": this.userController.getModel().id(),
        "ModelID": id,
        "FileType": type
    });
};


ContentServerClient.prototype.checkModelStatus = function(type, id, sync){
    var path = this.getAssetPath('3dmodel', id) + '/' + type + '/status';

    return ContentServerHandler.csRequest('GET', path, {
         'Content-Type': 'application/json',
    }, null, sync, true, false, "attempting to check the conversion status of a 3D model file.", logError.criticality.MAJOR, {
        "Username": this.userController.getModel().name(),
        "UserID": this.userController.getModel().id(),
        "ModelID": id,
        "FileType": type
    });
};

ContentServerClient.prototype.convertResourceModel = function(type, id, progress, complete){
    var self = this;
    var path = this.getAssetPath('3dmodel', id) + '/' +type + '/convert';

    return ContentServerHandler.csRequest('POST', path, {
        'Content-Type': 'application/json'
    }, null, false, false, "attempting to initiate a 3D model conversion.", logError.criticality.MAJOR, {
        "Username": this.userController.getModel().name(),
        "UserID": this.userController.getModel().id(),
        "ModelID": id,
        "FileType": type
    });
};

ContentServerClient.prototype.getEmptyColabDoc = function(type, id, datamodel_version, sync){
    console.assert(!this.datamodel_version, 'datamodel_version undefined');
    var path = this.getAssetPath(type, id) + '/emptyColabDoc?datamodel_version=' + datamodel_version;
    return ContentServerHandler.csRequest('GET', path, {
            'Content-Type': 'application/json'
    }, null, sync, true, false, "attempting to retrieve empty collab doc.", logError.criticality.MAJOR, {
        "Username": this.userController.getModel().name(),
        "UserID": this.userController.getModel().id(),
        "AssetID": id
    });
};

ContentServerClient.prototype.getSuggestedPackagesFromEcadIo = function(path, data) {
    return ContentServerHandler.csRequest('GET', path, {}, data, false, false, false, "attempting to retrieve suggested packages from EcadIO.", logError.criticality.MINOR);
};

ContentServerClient.prototype.importEagleLibraryFile = function(type, id, file, sync){
    var self = this;
    var formData = new FormData();
    // Check the file type.
    if (!file.name.toLowerCase().match('.*\.(lbr|intlib|schlib|pcblib|olb)')) {
        throw new Error("Wrong file");
    }

    // Add the file to the request.
    formData.append(file.name, file, file.name);

    var path = this.getAssetPath(type, id) + '/import';
    function f() {
        return ContentServerHandler.csRequest('POST', path, {}, formData, sync, true, false, "attempting to import an eagle library.", logError.criticality.MAJOR, {
            "Username": self.userController.getModel().name(),
            "UserID": self.userController.getModel().id(),
            "AssetID": id
        });
    }
    //modify response so that asset info in response is replaced with assetData in case of no error
    function updateResponseWithAssetData(response) {
        //replace resource info with asset data in case of no error
        if(response['resource']) {
            response['resource'] = new AssetData(response['resource']);
        }
        return response;
    }

    if(sync) {
        return updateResponseWithAssetData(f());
    } else {
        return f().then(updateResponseWithAssetData);
    }
};


ContentServerClient.prototype.getEagleLibraryExport = function(type, id, datamodel_version, sync){
    var path = this.getAssetPath(type, id) + '/export?type=eagle&datamodel_version=8.7.0&version='+datamodel_version;
    return ContentServerHandler.csRequest('GET', path, {}, null, sync, false, false, "attempting to export an eagle library.",  logError.criticality.MAJOR, {
            "Username": this.userController.getModel().name(),
            "UserID": this.userController.getModel().id(),
            "AssetID": id,
            "Datamodel": "Version "+ datamodel_version
        });
};



ContentServerClient.prototype.getImportStatus = function(type, id, sync){
    var path = this.getAssetPath(type, id) + '/import/status';

    return ContentServerHandler.csRequest('GET', path, {'Content-Type': 'application/json'}, null, sync, true, false, "attempting to get an import status.",  logError.criticality.MAJOR, {
            "Username": this.userController.getModel().name(),
            "UserID": this.userController.getModel().id(),
            "AssetID": id
        });
};

ContentServerClient.prototype.importEagleLibraryURL = function(type, id, url, sync){
    var path = this.getAssetPath(type, id) + '/import?libraryURL=' + url;
    return ContentServerHandler.csRequest('POST', path, {}, null, sync, true, false, "attempting to import a library URL.",  logError.criticality.MAJOR, {
        "Username": this.userController.getModel().name(),
        "UserID": this.userController.getModel().id(),
        "AssetID": id
    });
};

ContentServerClient.prototype.generate3dModelForIPCPackageType = function(packageType, output, ipcParams, sync) {
    var path = this.contentServerURL + '/actions/ipc3dModelGenerator/' + packageType;
    path += '?output=' + output;

    for(var p in ipcParams) {
        path += '&' + p + '=' + ipcParams[p];
    }

    return ContentServerHandler.csRequest('GET', path, {'Content-Type':'application/json'}, null, sync, true, false, "attempting to generate an IPC 3D model.",  logError.criticality.MINOR, {
        "Username": this.userController.getModel().name(),
        "UserID": this.userController.getModel().id(),
        "PackageType": packageType
    });
};
